import { Component } from '@angular/core';

@Component({
    selector: 'cb-stepper',
    templateUrl: './stepper.component.html',
    styleUrls: ['./stepper.component.scss'],
    standalone: false
})
export class StepperComponent { }
